import { render, staticRenderFns } from "./search-filter-checkbox.vue?vue&type=template&id=3fa938b2&scoped=true"
import script from "./search-filter-checkbox.vue?vue&type=script&lang=ts"
export * from "./search-filter-checkbox.vue?vue&type=script&lang=ts"
import style0 from "./search-filter-checkbox.vue?vue&type=style&index=0&id=3fa938b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa938b2",
  null
  
)

export default component.exports